<template>
	<input class="ImgBtn" @change="fileUp" type="file"  ref="ImgBtn"/>
</template>
 
<script>
export default {
	props:{
		value:Object,
		config:Object
	},
  	methods: {
		click(){		
			this.$refs.ImgBtn.click();
		},
		fileUp(flie){
			this.push(flie.target.files[0]); 		
		},
		push(fld){
			let arr = ['image/gif','image/jpeg','image/png'];
			let maxN = 0;
			if(this.config && this.config.uptype){
				arr = this.config.uptype;
			}
	
			if(arr.indexOf(fld.type)==-1){
				this.$refs.ImgBtn.value ='';
				this.tipA('请选择正确格式的文件上传')
				return
			}
			if(this.config && this.config.upmax){
				maxN = this.config.upmax
			}
			console.log(maxN)
			if(maxN && maxN<fld.size){
				this.$refs.ImgBtn.value ='';
				this.tipA('请选择正确大小的文件上传')
				return
			}

			this.postImg(fld,this.on);			
		},
		postImg (fld) {		
			let formData = new FormData();
			let access_token = '';
			if(window.userInfo){
				access_token = window.userInfo.access_token;
			}
			formData.append('access_token',access_token)
	
			formData.append('file',fld)				
			let xhr = new XMLHttpRequest();
			this.value.type = 1;					
			this.value.bfb = 0;
			this.value.img = '';
			this.$set(this.value,'ajax',xhr);
		
			let uploadProgress = (evt)=>{
				if(evt.lengthComputable) {
					let pn = Math.floor(Math.round(evt.loaded * 100 / evt.total));
					if(pn==100){return}
					this.value.bfb = pn;
				}
			};
			let uploadComplete = (data)=>{
				this.value.bfb = 100;
				setTimeout(()=>{
					this.$refs.ImgBtn.value ='';
					if(data.currentTarget.response){
						let da = JSON.parse(data.currentTarget.response).data;	
						this.value.img = da.url;
					
						this.value.type=2;		
					}else{
						this.value.type=0;
					}
				
				},200)
			
				
			};
			let uploadFailed = ()=>{
				this.$refs.ImgBtn.value ='';
				this.tipA('文件上传失败请稍后重试');				
			};
			let uploadCanceled = ()=>{
				this.$refs.ImgBtn.value ='';
			};
			xhr.upload.addEventListener("progress",uploadProgress, false);
			xhr.addEventListener("load",uploadComplete, false);
			xhr.addEventListener("error",uploadFailed, false);
			xhr.addEventListener("abort",uploadCanceled, false);
	
			xhr.open("POST", window.file_upload_baseURL);
			xhr.send(formData);
		}
	}
}
</script>

<style lang="scss">
.ImgBtn{
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	opacity: 0;
}
</style>	